import { Component, OnInit } from '@angular/core';
import { CommonFunctionService, UserPOSData} from '../../../services/Common/common-function.service';
import { BusinessInfoService } from '../../../POS/POSServices/Business/business-info.service';
import { Router } from '@angular/router';
import { Category } from '../../models/category';
@Component({
  selector: 'app-setupbusiness',
  templateUrl: './setupbusiness.component.html',
  styleUrls: ['./setupbusiness.component.scss']
})
export class SetupbusinessComponent implements OnInit {
  posId:any;
  merchantdata: UserPOSData ;
  personalInfoComplete = true;
  addressComplete = false;
  creditCardComplete = false;
  completedOrder = false;
  addproducts= false;
  additems= false;
  selecttheme = false;
  stepOne = false;
  stepTwo = false;
  stepThree = false;
  stepFour = false;
  stepFive = false;
  stepSix = false;
  selectorder:boolean=false;


  customerInformation = [];


  fruite = ['apple','orange'];

  

  name;


  constructor(private commonfunction: CommonFunctionService, private service:BusinessInfoService,private router: Router) {
  

    
   }

  ngOnInit() {
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    this.posId= merchantdata.PosSubscriptionId;
    this.service.GetgetBusinessInfo(this.posId).subscribe(result => {   
      if(result !=null)
      {

        this.service.GetTaxfeedetails(this.posId).subscribe(res => { 
          if(res.length > 0)
          {
            this.service.GetCategorydetails(this.posId).subscribe(res => {
              if(res.length > 0)
              {
                this.service.GetItemdetails(this.posId).subscribe(res => {
                  if(res.length > 0)
                  {
                    this.service.Getorderdetails(this.posId).subscribe(res => {
                      if(res.length>0)
                      {
                        this.router.navigate(["/pos"]);
                      }
                      else
                      {
                        this.ordercreationTab();
                      }
                    })
                    
                  }
                  else
                  {
                    this.itemsTab();
                  }
                });
              }
              else{
                this.Categorytab();
              }
            })
          }
          else{
            this.Taxfeetab();
          }
         });
      }
      else{
        this.router.navigate(["/pos/setup"]);
      }
      });
  }
  personalInfoSubmit() {
    // this.personalInfoComplete = false;
    // this.addressComplete = true;
    // this.additems = false;
    // this.addproducts = false;
    // this.selecttheme = false;
    // this.stepOne = true; 

    this.router.navigate(["/pos/businessinfo"]);



 

     
  }

  addressSubmit() {
    // this.addressComplete = false;
    // this.creditCardComplete = true;
    // this.stepTwo = true;
    this.router.navigate(["/pos/taxfee/new"]);
  }

  creditCardSubmit() {
    // this.creditCardComplete = false;
    // this.completedOrder = false;
    // this.addproducts = true;
    // this.stepThree = true;
    this.router.navigate(["/pos/category/new"]);
  }
  productsubmit(){
    // this.creditCardComplete = false;
    // this.completedOrder = false;
    // this.addproducts = false;
    // this.additems = true; 
    // this.stepFour = true;
    this.router.navigate(["/pos/item/new"]);
  }
  Ordercreate()
  {
    this.router.navigate(["/pos/orders/new"]);
  }
  itemsubmit(){
    this.router.navigate(["/pos/item/new"]);
    // this.creditCardComplete = false;
    // this.completedOrder = false;
    // this.addproducts = false;
    // this.selecttheme = true;
    // this.stepFour = true;
    // this.stepFive = true;
  } 

Businessinfodeail()
{
    this.personalInfoComplete = false;
    this.addressComplete = true;
    this.additems = false;
    this.addproducts = false;
    this.selecttheme = false;
    this.stepOne = true; 
    this.selectorder=false;

}
Taxfeetab() {
  this.addressComplete = false;
  this.creditCardComplete = true;
  this.stepOne = true;
  this.stepOne = true; 
  this.stepThree = false; 
  this.personalInfoComplete=false;
  this.addressComplete=true;
  this.creditCardComplete=false;
  this.selectorder=false;
}

Categorytab()
{
  this.creditCardComplete = true;
    this.completedOrder = false;
    this.addproducts = false;
    this.stepOne = true;
    this.stepTwo = true; 
    this.stepThree = false; 
    this.stepFour = false; 
    this.personalInfoComplete=false;
    this.addressComplete=false;
    this.selectorder=false;
    
}
itemsTab()
{
  this.creditCardComplete = false;
  this.completedOrder = false;
  this.personalInfoComplete=false;
  this.addproducts = false;
  this.selecttheme = true;
  this.stepOne = true;
  this.stepTwo = true; 
  this.stepThree = true; 
  this.stepFour = false;
  this.stepFive = false;
  this.additems=true;
}
ordercreationTab()
{
  this.creditCardComplete = false;
  this.completedOrder = false;
  this.personalInfoComplete=false;
  this.addproducts = false;
  this.selecttheme = true;
  this.stepOne = true;
  this.stepTwo = true; 
  this.stepThree = true; 
  this.stepFour = true;
  this.stepFive = false;
  this.selectorder=true;
  this.additems=false;
  this.addproducts=false
}
}
